var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 6.66699L11.6667 1.66699H5.00001C4.55798 1.66699 4.13406 1.84259 3.8215 2.15515C3.50894 2.46771 3.33334 2.89163 3.33334 3.33366V16.667C3.33334 17.109 3.50894 17.5329 3.8215 17.8455C4.13406 18.1581 4.55798 18.3337 5.00001 18.3337H15C15.442 18.3337 15.866 18.1581 16.1785 17.8455C16.4911 17.5329 16.6667 17.109 16.6667 16.667V6.66699ZM7.50001 15.8337H5.83334V8.33366H7.50001V15.8337ZM10.8333 15.8337H9.16668V10.8337H10.8333V15.8337ZM14.1667 15.8337H12.5V13.3337H14.1667V15.8337ZM11.6667 7.50033H10.8333V3.33366L15 7.50033H11.6667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReport);
export default __webpack_public_path__ + "static/media/icon__report.8f70a87f3842a6de4dbb01fb68b945a1.svg";
export { ForwardRef as ReactComponent };